import React from "react";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import LazyImage from "../../../components/common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { t } from "i18next";
import { commaSeperator, convertMilesToKm,/* fetchApi,*/ getInitials } from "../../../utils/methods";
import { LeaderboardContainer, AnswerColumn, LeaderboardHeader, LeaderboardRow, RankColumn, RankText, UserColumn, NewUserName/*,PaginationCircleNew */ } from "./styles";
// 
import { NameInitials } from "../../Manager/styles";
const TeamOverviewLeaderboard = ({ challenge, teamUsers }) => {

  const userDetails = useSelector((state) => state.profileData.user);
  const LoggedInUser = userDetails.uid;

  const getBackgroundColor = (/*user,*/ index, /*loggedInUserId*/) => {
    if (index + 1 === 1) return "#DDEEDF";
    if (index + 1 === 2) return "#EBECD5";
    if (index + 1 === 3) return "#FBE8E8";
    return "#F8F8F8";
  };

  const getTextColor = (/*user, index, loggedInUserId*/) => {
    window.console.log("hi")
    return "#005c87"
  };

  const DistanceUnit = localStorage.getItem('DISTANCE');

  window.console.log("challenge", challenge);

  return (
    <LeaderboardContainer>
      <div className="header">
        <div className="title">

          {(challenge?.team_challenge_details?.team_details?.logo !== "profile-Image/default.png" && challenge?.team_challenge_details?.team_details?.logo) ? <LazyImage
            style={{ width: "48px", height: "48px", borderRadius: "48px", border: "1px solid #DCDCDC" }}
            onError={() => window.console.error("Image failed to load")}
            src={`${ImageUrl}/${challenge?.team_challenge_details?.team_details?.logo}`}
          /> :
            <NameInitials>{getInitials(challenge?.team_challenge_details?.team_details?.name)}</NameInitials>
          }
          <span style={{ marginLeft: "20px" }}>{challenge?.team_challenge_details?.team_details?.name}</span>
        </div>
      </div>

      <LeaderboardHeader>
        <UserColumn> Team Members</UserColumn>
        <AnswerColumn>{challenge.event_type === "Total Steps" ? t("Steps Walked") : challenge.event_type === "Total Distance" ? t("Distance Covered") : t("Calories Burned")}</AnswerColumn>
        <RankColumn style={{ width: "auto" }}>Ranks</RankColumn>
      </LeaderboardHeader>

      {(
        teamUsers?.map((user, index) => (
          <LeaderboardRow key={user.uid} backgroundColor={getBackgroundColor(index)} textColor={getTextColor(user, index, LoggedInUser)} style={{ justifyContent: "space-between", width: "auto", cursor: challenge.is_team_challenge && "pointer" }} >
            <UserColumn>
              {user?.profile_image !== "profile-Image/default.png" ? (<LazyImage
                style={{ width: "48px", height: "48px", borderRadius: "48px", border: "1px solid #DCDCDC" }}
                onError={() => window.console.error("Image failed to load")}
                src={`${ImageUrl}/${user?.profile_image}`}
              />
              ) : <NameInitials>{getInitials(user?.fname)}{getInitials(user?.lname)}</NameInitials>}

              <NewUserName style={{ marginLeft: "20px" }}>{challenge.is_team_challenge ? user?.name : user?.fullname}</NewUserName>
            </UserColumn>
            {user?.is_joined ? <AnswerColumn style={{ width: "auto" }}>{challenge.event_type === "Total Steps" ? commaSeperator(user?.steps) : challenge.event_type === "Total Distance" ? DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(Math.round(user?.distance) || 0)) : commaSeperator(Math.round(user?.distance) || 0) : commaSeperator(Math.round(user?.calories))} {challenge.event_type === "Total Steps" ? t("steps") : challenge.event_type === "Total Distance" ? DistanceUnit === "KILOMETER" ? "Km" : t("Miles") : t("Calories")}</AnswerColumn> : "-"}

            {user?.is_joined ? <RankColumn style={{ width: "auto" }}>
              {index + 1}
              <RankText>{index + 1 === 1 ? "st" : index + 1 === 2 ? "nd" : index + 1 === 3 ? "rd" : "th"}</RankText>&nbsp;Rank
            </RankColumn> : <RankColumn style={{ width: "auto" }}><div className="notJoinedText">Not yet joined</div></RankColumn>}

          </LeaderboardRow>
        ))
      )}


    </LeaderboardContainer>
  );
};

TeamOverviewLeaderboard.propTypes = {
  selectedTab: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  challenge: PropTypes.object.isRequired,
  fetchChallengeCompetitors: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  challengeCompetitors: PropTypes.array,
  networkError: PropTypes.string,
  userId: PropTypes.number.isRequired,
  profileImage: PropTypes.string.isRequired,
  fetchTeamChallenge: PropTypes.func.isRequired,
  teamChallenge: PropTypes.array,
  competitorsCount: PropTypes.number,
  t: PropTypes.func,
  challengeAttendees: PropTypes.array,
  teamUsers: PropTypes.array,
};

export default TeamOverviewLeaderboard;